module.exports = __webpack_public_path__ + "static/media/400142_02.832b7bd1.png";